<template>
<div>
  <p id="gaica-kv"><img src="/img/insurance.jpg" alt="VIVA VIDA"></p>
  <main class="mt00">
    <h2 id="ttl-service">
    <span class="txt-en">Insurance for foreigners</span><br>
    外国人向け保険
    </h2>
    <p class="txt-service">
    &#9312; Medical care for foreigners.Life Insurance.（NO,１）<br>
    &#9313; Comprehensive Insurance for foreigner students.<br>
    &#9314; Insurance for foreign technical interns.
    </p>
    <p class="txt-service">
    &#9312; 外国人向け医療・生命保険（ナンバー１）<br>
    &#9313; 外国人留学生向け総合保険<br>
    &#9314; 外国人技能実習生向け保険
    </p>
    <p class="btn-service"><router-link to="" @click.native="clickLink">Read More</router-link></p>
  </main>
</div>
</template>

<script>
import firebase from 'firebase'

export default {
  data () {
    return {
      db: firebase.firestore(),
      uid :firebase.auth().currentUser.uid,
      path: "http://vivavida.net/Affiliate.php?af=135&pg=3",
      name: "HOKEN",
    }
  },
  methods: {
    clickLink () {
      this.db.collection("service_link_click_histories").add({
        user_id : this.uid,
        name: this.name,
        clicked_at : firebase.firestore.FieldValue.serverTimestamp(),
      })
      open(this.path, "_blank")
    },
  },
}

</script>
